import React, { useState } from 'react';
import { Layout, Menu } from 'antd';

const { Content } = Layout;

import withAuth from '~/libs/withAuth';
import { ContentLayout, MainBlockLayout } from '~/components/layouts';
import ProfitLoss from '~/components/ProfitLoss';
import BalanceSheet from '~/components/BalanceSheet';
import Dashboard from '~/components/dashboard/Dashboard';
import TaxReturn from '~/components/TaxReturn/TaxReturn';

const menuItems = [
  { key: 'dashboard', label: 'Dashboard' },
  { key: 'profitLoss', label: 'Profit & Loss' },
  { key: 'balanceSheet', label: 'Balance Sheet' },
  { key: 'taxReturn', label: 'Tax Return' }
];

const Reports = () => {
  //const { user } = useGlobalState();
  const [ section, setSection ] = useState('dashboard');

  const jsxMenu = <Menu mode='horizontal' defaultOpenKeys={['statements', 'metrics']}
    defaultSelectedKeys={section} items={menuItems} onClick={e => setSection(e.key)}>
  </Menu>;

	return (
    <ContentLayout>
      <MainBlockLayout title='Home' menu={jsxMenu} actions={[]}>
        {section === 'dashboard' && <Dashboard />}
        {section === 'profitLoss' && <ProfitLoss />}
        {section === 'balanceSheet' && <BalanceSheet />}
        {section === 'taxReturn' && <TaxReturn />}
      </MainBlockLayout>
    </ContentLayout>
	);
};

export default withAuth(Reports);